import Axios from "axios";
import { createToast } from "mosha-vue-toastify";

const APIBaseURL = process.env.VUE_APP_BACKEND_URL;

const adapter = Axios.create({
  baseURL: APIBaseURL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.VUE_APP_API_KEY,
  },
});

function eachRecursive(obj) {
  for (var k in obj) {
    if (typeof obj[k] == "object" && obj[k] !== null) eachRecursive(obj[k]);
    else if (obj[k] == null) obj[k] = "";
  }
}

export default {
  install(app) {
    adapter.interceptors.response.use(
      (response) => {
        eachRecursive(response.data);
        return response;
      },
      (error) => {
        if (error.response || error.message === "Network Error") {
          console.log("Can't reach server");
          createToast("Can't reach server, please try again later", {
            position: "bottom-center",
            hideProgressBar: true,
            toastBackgroundColor: "blue",
          });
        }

        return Promise.reject(error);
      }
    );

    var api = {
      getStatus() {
        return adapter.get(`/status`);
      },
      getGenerationById(id) {
        return adapter.get(`/bridge/generation/${id}`);
      },
      registerView(id) {
        return adapter.post(`/bridge/generation/${id}/view`);
      },
      voteGeneration(id, emoji) {
        return adapter.post(`/bridge/generation/${id}/vote`, { emoji });
      },
    };
    app.provide("api", api);
  },
};
